module.exports = __webpack_public_path__ + "media/images/Your_tutor-32e7ea63.png";